export { c as config, a as configureSDK } from './config-I7A9m-Yy.js';
//# sourceMappingURL=config.esm.js.map
